import { Contract, providers, Signer } from 'ethers';
import Contracts from '@tokenysolutions/t-rex';

import { contractFactory, OverrideTransactionsInterface } from '../utils/utils';

/**
 * Checks if a transfer is Compliant with Compliance policy
 * @param {{signer: Signer; overrides: OverrideTransactionsInterface}} contract
 * @returns {Promise<Contract>}
 */
export async function deployCompliance(contract: { signer: Signer; overrides: OverrideTransactionsInterface }): Promise<Contract> {
  const factory = contractFactory({
    abi: Contracts.contracts.DefaultCompliance.abi,
    bytecode: Contracts.contracts.DefaultCompliance.bytecode,
    signer: contract.signer,
  });
  const deploy = await factory.deploy(contract.overrides);
  return await deploy.deployed();
}

/**
 * Transfers the Ownership of the Compliance to a new Owner.
 * @param {{newOwner: string; compliance: Contract; overrides: OverrideTransactionsInterface}} tx
 * @returns {Promise<TransactionResponse>}
 */
export async function transferComplianceOwnership(tx: {
  newOwner: string;
  compliance: Contract;
  overrides: OverrideTransactionsInterface;
}): Promise<providers.TransactionResponse> {
  return await tx.compliance.transferOwnershipOnComplianceContract(tx.newOwner, tx.overrides);
}

/**
 * Returns true if the Address is in the list of token agents
 * @param tx
 */
export async function isTokenAgent(tx: { address: string; compliance: Contract; overrides: OverrideTransactionsInterface }): Promise<boolean> {
  return await tx.compliance.isTokenAgent(tx.address, tx.overrides);
}

/**
 * Returns true if the address given corresponds to a token that is bound with the Compliance contract
 * @param tx
 */
export async function isTokenBound(tx: { tokenAddress: string; compliance: Contract; overrides: OverrideTransactionsInterface }): Promise<boolean> {
  return await tx.compliance.isTokenBound(tx.tokenAddress, tx.overrides);
}

/**
 * adds an agent to the list of token agents
 * @param tx
 */
export async function addTokenAgent(tx: {
  tokenAgent: string;
  compliance: Contract;
  overrides: OverrideTransactionsInterface;
}): Promise<providers.TransactionResponse> {
  return await tx.compliance.addTokenAgent(tx.tokenAgent, tx.overrides);
}

/**
 * removes Agent from the list of token agents
 * @param tx
 */
export async function removeTokenAgent(tx: {
  tokenAgent: string;
  compliance: Contract;
  overrides: OverrideTransactionsInterface;
}): Promise<providers.TransactionResponse> {
  return await tx.compliance.removeTokenAgent(tx.tokenAgent, tx.overrides);
}

/**
 * binds a token to the compliance contract
 * @param tx
 */
export async function bindToken(tx: {
  tokenAddress: string;
  compliance: Contract;
  overrides: OverrideTransactionsInterface;
}): Promise<providers.TransactionResponse> {
  return await tx.compliance.bindToken(tx.tokenAddress, tx.overrides);
}

/**
 * unbinds a token from the compliance contract
 * @param tx
 */
export async function unbindToken(tx: {
  tokenAddress: string;
  compliance: Contract;
  overrides: OverrideTransactionsInterface;
}): Promise<providers.TransactionResponse> {
  return await tx.compliance.unbindToken(tx.tokenAddress, tx.overrides);
}

/**
 * Returns the Owner of the Compliance.
 * @param {{compliance: Contract; overrides: OverrideTransactionsInterface}} tx
 * @returns {Promise<TransactionResponse>}
 */
export async function getOwnerOfCompliance(tx: { compliance: Contract }): Promise<string> {
  return await tx.compliance.owner();
}
